import React from "react";
import "../CSS/Footer.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaYoutube, FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
    

      {/* Main Footer Content */}
      <div className="footer-content">
        <div className="footer-section">
          <img src={require("../Images/LogoWithTagline.jpeg")} alt="Logo" className="footer-logo" />
          <p>AMFI Registered Mutual Fund Distributor</p>
        </div>

        <div className="footer-section">
          <h4>Our Services</h4>
           <ul>
            <li>Mutual Funds</li>
            <li>PMS</li>
            <li>AIF</li>
            <li>Unlisted Shares</li>
            <li>Insurance</li>
          </ul>
        </div>

        

        <div className="footer-section fs-4">
          <h4>Get In Touch</h4>
          <p><FaMapMarkerAlt /> C-61 A Office No 201-202 Paradise, Sarojini Marg, opposite Aunty Cafe, C Scheme, Jaipur, Rajasthan 302001</p>
          <p><FaPhoneAlt /> +91 - 9875085100</p>
          <p><FaPhoneAlt /> +91 - 8875085100</p>
          <p><FaEnvelope /> valuefundz@gmail.com</p>
          <div className="footer-socials">
          <div className="footer-socials">
            <a href="https://www.facebook.com/profile.php?id=100063756532919" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.youtube.com/@valuefundz" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>
            <a href="https://www.linkedin.com/company/value-fundz-private-limited/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
            <a href="https://www.instagram.com/value.fundz" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </div>

          </div>
        </div>

        <div className="footer-section map">
          <h4>Find Us</h4>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.8177519380274!2d75.80017077626123!3d26.909278476649277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db571a0995969%3A0xcf5ab02dc3af5021!2sVALUEFUNDZ%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1746860336668!5m2!1sen!2sin" 
            width="100%"
            height="200"
            style={{ border: 0 }}
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          Risk Factor – Investments are subject to market risks...<br />
          ARN - 171060 | Grievance Officer: Mr. Mukesh Tekwani | Email: valuefundz@gmail.com
        </p>
        <div className="footer-links">
          <a href="/">Disclaimer</a>
          <a href="/">Disclosure</a>
          <a href="/">Privacy Policy</a>
          <a href="/">Terms & Conditions</a>
        </div>
        <p className="copyright">© 2025 ValueFundz Pvt. Ltd. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
